import React from 'react';
import { Flex, Text, Title } from '@gjensidige/builders-components';

import styles from './style.scss';
import { CalculationInputs } from './components/CalculationInputs/CalculationInputs';
import { IllustrationSection } from './components/IllustrationSection/IllustrationSection';
import { CalculationWidgetProps } from './Types';

export const CalculationWidget: React.FC<CalculationWidgetProps> = (
  props: CalculationWidgetProps
) => {
  const {
    image,
    imageAltText,
    smallScreenImage,
    hideImageOnSmallScreens,
    headerText,
    inputLists,
    footerMessageClassName,
    footerMessage
  } = props;

  return (
    <Flex>
      <div className={`${styles.widgetWrapper}`}>
        <Flex layout={{ sm: 1, md: 2 }}>
          <div className={`${styles.imageContainer} ${hideImageOnSmallScreens ? styles.hideImgOnSmall : ''}`}>
            <IllustrationSection
              imageUrl={image}
              imageAltText={imageAltText}
              smallScreenImage={smallScreenImage}
            />
          </div>
          <Flex center="md" className={`${styles.inputContainer} ${hideImageOnSmallScreens ? styles.mt0 : ''}`}>
            <div className={styles.inputContentWrapper}>
              <Title
                as={'h2'}
                size="5"
                className={styles.calculationWidgetHeader}
              >
                {headerText}
              </Title>
              <div className={styles.calculationWidgetInputSection}>
                <div className={styles.rightContainer}>
                  <CalculationInputs
                    calculationInputs={inputLists.calculationInputs}
                    calculateBtn={inputLists.calculateBtn}
                  />
                  {footerMessage && (
                    <Text
                      size="small"
                      className={`${styles.footerInfo} ${footerMessageClassName}`}
                    >
                      {footerMessage}
                    </Text>
                  )}
                </div>
              </div>
            </div>
          </Flex>
        </Flex>
      </div>
    </Flex>
  );
};
